export enum Plan {
  FREE = 'free',
  VERIFIED = 'verified',
  CONCIERGE = 'concierge',
}
